import type { Clock, Instant, Micros, TimerHandle } from "./types.js";
import { hostTimeout } from "./host-timer.js";
import { TidMinter } from "./tid.js";

/**
 * Production binding (ADR-13): system time, host timers. Deliberately has NO
 * applyClockState / applySpanReplay — a production instance cannot be
 * fast-forwarded, full stop. NTP discipline/skew monitoring is an ops concern.
 */
export class SystemClock implements Clock {
  private readonly minter: TidMinter;
  private lastNow = 0;

  /** clkid: 10-bit instance id for TIDs; random by default. */
  constructor(clkid: number = Math.floor(Math.random() * 1024)) {
    this.minter = new TidMinter(clkid);
  }

  now(): Instant {
    const computed = Date.now() * 1000;    // wallclock-allow: THE system-time read (ADR-13 SystemClock binding)
    this.lastNow = Math.max(this.lastNow, computed);
    return this.lastNow;
  }

  tid(): string { return this.minter.mint(this.now()); }

  at(t: Instant, cb: () => void): TimerHandle {
    return this.after(Math.max(0, t - this.now()), cb);
  }

  after(d: Micros, cb: () => void): TimerHandle {
    const timer = hostTimeout(cb, d / 1000); // chained past Node's 2^31-1 ms setTimeout clamp
    return { cancel: () => timer.clear() };
  }
}
